module.exports = new __parcel__URL__("Step_4.f48884d4.jpg").toString();